module.exports = __webpack_public_path__ + "img/logo.ccec0847.png";